import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Estado para administrar el Spinner de carga
 */
@Injectable({ providedIn: 'root' })
export class SpinnerState {
  private requestCount = new BehaviorSubject<number>(0);
  public display = this.requestCount.asObservable();
  /** bandera que indica si se debe visualizar el spinner */
  public display_v0: boolean;

  /**
   * Constructor del spinner que inicializa la bandera
   */
  constructor() {
    this.display_v0 = false;
  }

  /**
   * Metodo que permite visualizar el spinner
   */
  public displaySpinner_v0(): void {
    this.display_v0 = true;
  }

  /**
   * Metodo que permite ocultar el spinner
   */
  public hideSpinner_v0(): void {
    this.display_v0 = false;
  }

  public displaySpinner(): void {
    this.requestCount.next(this.requestCount.value + 1);
  }

  public hideSpinner(): void {
    if (this.requestCount.value > 0) {
      this.requestCount.next(this.requestCount.value - 1);
    }
  }
}
